import { useEffect, useRef, useState } from "react";
import { sendMessageToGemini, isGeminiConfigured } from "../../../../../services/geminiService";

export function useAiAdvisorChat(report, aiAnalysis = null) {
  const [chatMessages, setChatMessages] = useState([
    {
      role: "ai",
      text: `Ciao! Sono il tuo AI Advisor specializzato in ambito assicurativo${
        report?.businessName ? ` per ${report.businessName}` : ""
      }. Come posso aiutarti con la tua analisi dei rischi?`,
    },
  ]);

  const [userInput, setUserInput] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const chatEndRef = useRef(null);
  const isInitialMount = useRef(true);
  const previousAiAnalysis = useRef(aiAnalysis);

  // Update chat context when AI analysis becomes available
  useEffect(() => {
    // Se l'analisi AI è diventata disponibile dopo il mount iniziale
    if (aiAnalysis && !previousAiAnalysis.current) {
      console.log("AI Analysis is now available, updating chat context");
      // Non serve aggiungere un messaggio, il contesto verrà passato automaticamente
      // nelle chiamate successive a sendMessageToGemini
    }
    previousAiAnalysis.current = aiAnalysis;
  }, [aiAnalysis]);

  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
      return;
    }
    chatEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [chatMessages]);

  const send = async () => {
    if (userInput.trim() === "") return;

    if (!isGeminiConfigured()) {
      setError("Gemini AI non è configurato correttamente. Verifica la API key nel file .env");
      return;
    }

    const userMessage = userInput.trim();
    const newMessages = [...chatMessages, { role: "user", text: userMessage }];

    setChatMessages(newMessages);
    setUserInput("");
    setIsLoading(true);
    setError(null);

    try {
      const aiResponseText = await sendMessageToGemini(userMessage, chatMessages, report, aiAnalysis);
      setChatMessages([...newMessages, { role: "ai", text: aiResponseText }]);
    } catch (err) {
      setError(err?.message || "Si è verificato un errore. Riprova.");
      setChatMessages([
        ...newMessages,
        { role: "ai", text: "Mi dispiace, si è verificato un errore nella comunicazione. Per favore riprova." },
      ]);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    chatMessages,
    userInput,
    setUserInput,
    isLoading,
    error,
    setError,
    send,
    chatEndRef,
  };
}